import * as React from 'react';
import { globalMessage } from '@/utils/globalMessage';
import { antGrey, runwayColors } from '../styles/globalStyles';
import TooltipInfoIcon from '../helperComponents/TooltipInfoIcon';

export const monoStyle: React.CSSProperties = {
    fontFamily: 'SFMono-Regular, Consolas, Menlo, monospace',
    fontSize: 13,
};

export const codeBlockStyle: React.CSSProperties = {
    ...monoStyle,
    margin: 0,
    fontSize: 12,
    lineHeight: '18px',
    background: runwayColors.white,
    border: `1px solid ${antGrey.grey4}`,
    borderRadius: 8,
    padding: '8px 12px',
    color: antGrey.grey8,
    whiteSpace: 'pre',
    overflow: 'auto',
};

export const panelStyle: React.CSSProperties = {
    background: runwayColors.white,
    border: `1px solid ${antGrey.grey4}`,
    borderRadius: 8,
};

export const InfoTip: React.FC<{ title: React.ReactNode }> = ({ title }) => (
    <TooltipInfoIcon tooltipContent={title} style={{ marginLeft: 6 }} />
);

export const StepBox: React.FC<{ gap?: number; style?: React.CSSProperties; children: React.ReactNode }> = ({
    gap = 16,
    style,
    children,
}) => (
    <div style={{ ...panelStyle, padding: 16, display: 'flex', flexDirection: 'column', gap, ...style }}>
        {children}
    </div>
);

export const StepLine: React.FC<{ number: number; children: React.ReactNode }> = ({ number, children }) => (
    <div style={{ display: 'flex', gap: 12 }}>
        <span
            style={{
                width: 22,
                height: 22,
                borderRadius: 11,
                border: `1px solid ${antGrey.grey5}`,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                flexShrink: 0,
                color: antGrey.grey8,
                background: runwayColors.white,
            }}
        >
            {number}
        </span>
        <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>{children}</div>
    </div>
);

export const copyToClipboard = (text: string, label: string) => {
    const blocked = () => globalMessage.warning('Copy is blocked here. Select the text instead.');
    if (!navigator.clipboard) {
        blocked();
        return;
    }
    navigator.clipboard.writeText(text).then(() => globalMessage.success(`${label} copied to clipboard`), blocked);
};
